import CommonHelp from "./CommonHelp";
import Confirm from "iview/src/components/modal/confirm";
import {Message} from "element-ui";

export default class Api{

  // 收款列表
  static incomeList(where , page , page_size , callback, error = undefined){
    CommonHelp.get("FinanceIncome/getList",{
      where:JSON.stringify(where),
      page: page ,
      page_size: page_size,
    },res=>{
      if(res.code) {
        callback(res.data);
      }else{
        if(error !== undefined){
          error();
        }
      }
    })
  }

  // 删除收款
  static incomeDel(id ,callback){
    CommonHelp.post('FinanceIncome/delete' , {id:id} , res=>{
      if(res.code){
        callback(res);
        Message.success(res.msg);
      }else{
        Message.error(res.msg);
      }
    })
  }

  // 操作日志
  static operatorLog(data_id , data_type , page , page_size , callback){
    CommonHelp.get('OperatorLog/getList' ,
      {where : {data_type : data_type , data_id : data_id} , page : page , page_size : page_size} , res => {
      if(res.code){
        callback(res.data);
      }else{
        Message.error(res.msg);
      }
    })
  }

  // 导出收款记录
  static downloadIncomeArrears(where){
    CommonHelp.get('FinanceIncome/download' , {where : where} , res => {
      if(res.code){
        let url = CommonHelp.getBaseURL() + res.data ;
        window.open(url);
      }else{
        Message.error(res.msg)
      }
    })
  }

  // 导出收款计划模板
  static downloadPlanTemplate(where)
  {
    CommonHelp.get('FinancePlan/download_template' , {where : where} , res => {
      if(res.code){
        let url = CommonHelp.getBaseURL() + res.data ;
        window.open(url);
      }else{
        Message.error(res.msg)
      }
    })
  }

  // 导出收款计划模板
  static downloadPlanData(where)
  {
    CommonHelp.get('FinancePlan/download_data' , {where : where} , res => {
      if(res.code){
        let url = CommonHelp.getBaseURL() + res.data ;
        window.open(url);
      }else{
        Message.error(res.msg)
      }
    })
  }

  // 获取上传文件地址
  static getUploadUrl(url){
    return CommonHelp.getBaseURL() + url + '?token=' + localStorage.getItem('token') + '&login_name=' + localStorage.getItem('login');
  }

  // 收款计划列表
  static planList(where , callback){
    CommonHelp.get('FinancePlan/get_plan_list' , {where : where} , res => {
      if(res.code){
        callback(res.data);
      }else{
        Message.error(res.msg);
      }
    });
  }

  // 导出收款计划
  static exportPlan(where ){
    CommonHelp.get('FinancePlan/export_plan_list' , {where : where} , res => {
      if(res.code){
        let url = CommonHelp.getBaseURL() + res.data ;
        window.open(url);
      }else{
        Message.error(res.msg)
      }
    })
  }

  // 导出变动登记模板
  static downloadChangeTemplate(where){
    CommonHelp.get('Finance/exportTemplate' , {where : where} , res => {
      if(res.code){
        let url = CommonHelp.getBaseURL() + res.data ;
        window.open(url);
      }else{
        Message.error(res.msg)
      }
    })
  }

  // 导出开具发票模板
  static downloadInvoiceTemplate(where){
    CommonHelp.get('FinanceInvoice/exportTemplate' , {where : where} , res => {
      if(res.code){
        let url = CommonHelp.getBaseURL() + res.data ;
        window.open(url);
      }else{
        Message.error(res.msg)
      }
    })
  }

  // 导出收款模板
  static downloadIncomeTemplate(where) {
    CommonHelp.get('FinanceIncome/exportTemplate', {where: where}, res => {
      if (res.code) {
        let url = CommonHelp.getBaseURL() + res.data;
        window.open(url);
      } else {
        Message.error(res.msg)
      }
    })
  }

  // 导出合同变动数据
  static downloadFinanceChange(where){
    CommonHelp.get('Finance/exportData' , {where : where} , res => {
      if(res.code){
        let url = CommonHelp.getBaseURL() + res.data ;
        window.open(url);
      }else{
        Message.error(res.msg)
      }
    })
  }

  // 导出合同发票数据
  static downloadInvoiceData(where){
    CommonHelp.get('FinanceInvoice/exportData' , {where : where} , res => {
      if(res.code){
        let url = CommonHelp.getBaseURL() + res.data ;
        window.open(url);
      }else{
        Message.error(res.msg)
      }
    })
  }

  // 合同的发票列表
  static invoiceList(where ,page , page_size , callback){
    CommonHelp.get('FinanceInvoice/getInvoiceList' , {where : where , page : page , page_size : page_size} , res => {
      if(res.code){
        callback(res.data);
      }else{
        Message.error(res.msg);
      }
    });
  }

  // 删除合同发票
  static invoiceDel(id , callback){
    CommonHelp.post('FinanceInvoice/delete' , {id : id} , res => {
      if(res.code){
        callback(res);
        Message.success(res.msg);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Contract/common/Api.js